import { createSelector } from '@reduxjs/toolkit'
import { jobsAdapter } from './slice'
import { getCalcOutputState } from '../../../../../utils/selectors'
import { getJobID } from '../jobSettings'
import { getResultTableSettings } from '../result'
import { getSettingsState } from '../settings'
import { getJobSettingsState } from '../jobSettings'

import { CONNECTION_TYPE } from '../../../common/constants'
import { getHangerState } from '../hanger'
import { getHeaderState } from '../header'
import { getJoistState } from '../joist'
import { getTrussState } from '../truss'
import { getGirderState } from '../girder'
import { getLeftHipState } from '../leftHip'
import { getRightHipState } from '../rightHip'
import { getJackState } from '../jack'

export const getJobTallyState = (state) => getCalcOutputState(state).jobs

const { selectAll, selectById, selectEntities, selectIds, selectTotal } =
  jobsAdapter.getSelectors(getJobTallyState)

export const getEditedJob = (state) => getJobTallyState(state).editedJob
export const getEditMode = createSelector(getEditedJob, (editedJob) => editedJob !== null)
export const getExistedJob = createSelector(selectIds, getJobID, (ids, id) => ids.includes(id));

export { selectAll, selectById, selectEntities, selectIds, selectTotal }

export const getJobInputs = createSelector(
  getResultTableSettings,
  getSettingsState,
  getJobSettingsState,
  getHangerState,
  getJoistState,
  getHeaderState,
  getTrussState,
  getGirderState,
  getLeftHipState,
  getRightHipState,
  getJackState,
  (result, settings, jobSettings, hangerOptions, joist, header, truss, girder, leftHip, rightHip, jack) => {
    const connectionType = settings.connectionType
    const configuration = jobSettings.configuration

    const multiTrussMember = {
      leftCenter: { leftHip, jack },
      leftRight: { leftHip, rightHip },
      centerRight: { jack, rightHip },
    }[configuration] || { jack, leftHip, rightHip }

    const member = {
      [CONNECTION_TYPE.JOIST]: {
        joist, header
      },
      [CONNECTION_TYPE.TRUSS]: {
        truss, girder
      },
      [CONNECTION_TYPE.MULTI_TRUSS]: { girder, ...multiTrussMember },
    }

    return Object.assign(
      {},
      connectionType !== CONNECTION_TYPE.MULTI_TRUSS ? { hangerOptions } : {},
      member[connectionType],
      { settings, jobSettings, result },
    )
  },
)
